import {
    getCoreRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import '../../App.css';
import { DataTable } from './datatable';

import { useState } from 'react';
import DatatableSortButton from './datatableSortButton';

export const columns = [
    // {
    //     accessorKey: "id",
    //     header: ({ column }) => <DatatableSortButton column={column}>ID</DatatableSortButton>,
    //     meta: {
    //         headerClassName: "w-min",
    //     }
    // },
    {
        accessorKey: "created_at",
        header: ({ column }) => <DatatableSortButton column={column}>Tidpunkt</DatatableSortButton>,
        cell: info => {
            const date = new Date(info.row.original.created_at);
            return date.toLocaleDateString(undefined, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });
        }
    },
    {
        accessorKey: "performer",
        header: ({ column }) => <DatatableSortButton column={column}>Utövare</DatatableSortButton>,
        cell: info => {
            const performer = info.row.original.performer;
            if (performer && performer.first_name && performer.last_name) {
                return `${performer.first_name} ${performer.last_name}`;
            }
            return 'Ingen utövare';  // Handle cases where performer is null or undefined
        }
    },
    {
        accessorKey: "targetUser",
        header: ({ column }) => <DatatableSortButton column={column}>Användare</DatatableSortButton>,
        cell: info => {
            const tUser = info.row.original?.targetUser;
            if (tUser && tUser?.first_name && tUser?.last_name) {
                return `${tUser?.first_name} ${tUser?.last_name}`;
            }
            return 'Ingen användare';  // Handle cases where performer is null or undefined
        }
    },
    {
        accessorKey: "description",
        header: 'Beskrivning',
    },
];

export function ClubsLogDatatable({ data, isLoading }) {
    const [sorting, setSorting] = useState([{ id: 'created_at', desc: true }])

    const table = useReactTable({
        data: data,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        state: {
            sorting,
        },
    })

    return (
        <DataTable table={table} isLoading={isLoading} columns={columns} />
    )
}
